import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = ({ language }) => {
    const navigate = useNavigate();

    useEffect(() => {
      navigate('/');
    }, [navigate]);
  
    return null;
  
//   const isArabic = language === 'ar';

//   return (
//     <div className="not-found-container">
//       <div className="not-found-content">
//       <img src="logo.jpg" alt="Logo" className="about-logo" />
//         <h1 className={`not-found-title ${isArabic ? 'arabic-title' : 'english-title'}`} dir={isArabic ? 'rtl' : 'ltr'}>
//           {isArabic ? '٤٠٤ - الصفحة غير موجودة' : '404 - Page Not Found'}
//         </h1>

//         <p className="not-found-message" dir={isArabic ? 'rtl' : 'ltr'}>
//           {isArabic
//             ? 'عذراً، لم نتمكن من العثور على الصفحة التي تبحث عنها. لعل في هذا خيراً.'
//             : 'We apologize, but the page you are looking for cannot be found. Perhaps there is good in this.'}
//         </p>

//         <p className="not-found-quote" dir={isArabic ? 'rtl' : 'ltr'}>
//           {isArabic ? 'كُلُّ شَيْءٍ بِقَضَاءٍ وَقَدَرٍ' : 'Everything happens by divine decree'}
//         </p>

//         <div className="not-found-pattern"></div>
        
//         <Link to="/" className="not-found-button">
//           {isArabic ? 'العودة إلى الصفحة الرئيسية' : 'Return to Home Page'}
//         </Link>

//         <p className="not-found-calligraphy">
//           {isArabic ? 'وَمَا تَشَاءُونَ إِلَّا أَن يَشَاءَ اللَّهُ' : 'And you do not will except that Allah wills'}
//         </p>
//       </div>
//     </div>
//   );
};

export default NotFound;
